const root = window || this;
const doc = root.window.document;

export { root, doc };
